import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import i18n from 'i18n-js';
import {fontFamily} from '../../../helpers/fontFamily';
import {
  bandTeamNoteBg,
  bandTeamNoteBorder,
  bandTeamNoteText,
  touchTargetMin
} from '../../../style/adminTools';

const SENTENCES = {
  inventory_process: 'Inventory is being processed for every unscanned order.',
  inventory_unprocess:
    'Inventory is being unprocessed for every unscanned order.',
  stripe_billing_email_synced:
    'The email on the Stripe account was updated to match.',
  import_job_scheduled: 'The next scheduled import was set up.',
  tote_sets_rebuilt: 'Totes were rebuilt for the new maximum.',
  se_import_log_cleared: 'The saved store order import log was deleted.',
  schedule_import_mode_reset: 'The import schedule was reset to Daily.',
  dashboards_reset: "Every user's dashboard was reset to none.",
  shopify_limits_not_applied:
    'Shopify-billed tenant: the new limits were saved here but Shopify billing was not changed.',
  subscription_not_repriced_blank_id:
    'The Stripe subscription ID is blank, so the subscription price was not updated.',
  users_packing_slip_size_reset:
    "Every user's packing slip size was changed to match."
};

const t = (key, defaultValue, options) =>
  i18n.t(`adminTenantPage.${key}`, {defaultValue, ...options});

const sideEffectText = code =>
  SENTENCES[code]
    ? t(`sideEffect.${code}`, SENTENCES[code])
    : t(
        'sideEffect.unknown',
        'The server reported an extra effect we have no description for: {{effect}}',
        {effect: code}
      );

const SideEffectsNotice = ({effects, onDismiss}) => (
  <View
    testID="tenantPageSideEffects"
    accessibilityLiveRegion="polite"
    style={{
      backgroundColor: bandTeamNoteBg,
      borderColor: bandTeamNoteBorder,
      borderWidth: 1,
      borderRadius: 6,
      padding: 12,
      marginBottom: 12
    }}
  >
    <Text
      style={{
        fontFamily: fontFamily.font700,
        fontSize: 13,
        color: bandTeamNoteText,
        marginBottom: 4
      }}
    >
      {t('sideEffectsTitle', 'Also done automatically')}
    </Text>
    {effects.map(code => (
      <Text
        key={code}
        testID={`sideEffect-${code}`}
        style={{
          fontFamily: fontFamily.font500,
          fontSize: 13,
          color: bandTeamNoteText
        }}
      >
        {sideEffectText(code)}
      </Text>
    ))}
    <TouchableOpacity
      onPress={onDismiss}
      accessibilityRole="button"
      testID="tenantPageSideEffectsDismiss"
      style={{minHeight: touchTargetMin, justifyContent: 'center'}}
    >
      <Text
        style={{
          fontFamily: fontFamily.font700,
          fontSize: 13,
          color: bandTeamNoteText
        }}
      >
        {t('dismiss', 'Dismiss')}
      </Text>
    </TouchableOpacity>
  </View>
);

export default SideEffectsNotice;
